/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteAddressBookEntryRequest
 */
export interface DeleteAddressBookEntryRequest {
    /**
     * 
     * @type {string}
     * @memberof DeleteAddressBookEntryRequest
     */
    addressBookEntryId: string;
}

/**
 * Check if a given object implements the DeleteAddressBookEntryRequest interface.
 */
export function instanceOfDeleteAddressBookEntryRequest(value: object): value is DeleteAddressBookEntryRequest {
    if (!('addressBookEntryId' in value) || value['addressBookEntryId'] === undefined) return false;
    return true;
}

export function DeleteAddressBookEntryRequestFromJSON(json: any): DeleteAddressBookEntryRequest {
    return DeleteAddressBookEntryRequestFromJSONTyped(json, false);
}

export function DeleteAddressBookEntryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteAddressBookEntryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'addressBookEntryId': json['addressBookEntryId'],
    };
}

  export function DeleteAddressBookEntryRequestToJSON(json: any): DeleteAddressBookEntryRequest {
      return DeleteAddressBookEntryRequestToJSONTyped(json, false);
  }

  export function DeleteAddressBookEntryRequestToJSONTyped(value?: DeleteAddressBookEntryRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'addressBookEntryId': value['addressBookEntryId'],
    };
}

